<script lang="ts">
  import type { ContentBlock } from '@shared/ui/content';

  export let blocks: ContentBlock[] = [];
  export let classes = '';

  $: filteredBlocks = blocks.filter((block) => block.type === 'header');
</script>

{#if filteredBlocks.length}
  <section class="{classes}">
    <h3 class="text-default-500 mb-5 text-base">Table of Contents</h3>

    <ul class="list-disc pl-5">
      {#each blocks as block}
        {#if block.type === 'header'}
          <li class="text-base font-medium underline">
            <!-- eslint-disable-next-line -->
            <a href="#{block.id}" class="hover:text-default-600 transition-colors">{@html block.data.text}</a>
          </li>
        {/if}
      {/each}
    </ul>
  </section>
{/if}
